<template>
  <b-avatar v-if="hasImage" :src="getImage(img)" :size="size + 'em'" alt=""> </b-avatar>
  <b-avatar v-else :src="require('@/assets/paw_print.png')" :size="size + 'em'" alt=""> </b-avatar>
</template>

<script>
import { getImage } from '@/utils';

export default {
  name: 'BasePetIcon',
  props: {
    img: {
      type: String,
      default: null,
    },
    size: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    hasImage() {
      return !!this.img;
    },
  },
  methods: {
    getImage,
  },
};
</script>

<style scoped></style>
